// extracted by mini-css-extract-plugin
export default {"modalOverlay":"WorkTimeModal_modalOverlay__CVeR8","modalContent":"WorkTimeModal_modalContent__2GtpW"};